// PageTaxRate
/* eslint indent: 0 */

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import TaxRateForm from '../../../setting/taxrate/taxrate_form/taxrate_form.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import StateListItem from '../../../setting/taxrate/state_list_item/state_list_item.jsx'
import FormButton from '../../../common/form/button/button.jsx'
import Select from '../../../common/form/select/select.jsx'
import Util from '../../../lib/util.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'

class PageTaxRate extends BaseSettings {
  constructor (props) {
    super(props, 'setting-taxrate', 'setting-user', 'setting-taxrate')

    this.state = {
      loading: true,
      dataDate: null
    }

    this.data = {
      taxRates: [],
      saving: false,
      activeTaxRate: null,
      showStateAdd: false,
      currActiveIdx: null,
      usaStates: Util.getUsaStateOptions()
    }

    this._references = {
      pageHeader: React.createRef()
    }
    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataTaxRates(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataTaxRates (callback) {
    app.debug('PageTaxRate: _getDataTaxRates [start]')

    const params = {}
    app
      .service('/api/taxrate')
      .find(params)
      .then(result => {
        this.data.taxRates = _.sortBy(result.data, 'state')
        this._updateReferences(this.data.taxRates)
        callback(null)
      })
      .catch(err => {
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageTaxRate: _onDataReceived Error', err)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      app.debug('PageTaxRate: _onDataReceived [done]')
      this.setState({ loading: false, dataDate: new Date() })
    }
  }

  /* renderHeader() {
    return (
      <PageHeaderSetting title="setting.taxRate.titleTaxRate"
        pageIdent="setting-taxrate" ref={this._references.pageHeaderSetting}
        onChangePage={this._onChangePage.bind(this)}
        teamCountry={app.teamCountry}
        isDemo={app.isDemo}
        isQuickbookConnected={app.isQuickbookConnected()}
      />
    );
  } */

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  renderContent () {
    return (
      <div className='page-taxrate'>
        <div className='taxratecont'>
          <div className='colleft'>
            <div className='headertitle'>
              <IntlMessage ident='setting.taxRate.taxStateTitle' />
            </div>
            <div className='link'>
              <IntlMessage ident='setting.taxRate.taxStateInfo' />
              <a
                href={IntlUtil.convertMessage(
                  'setting.taxRate.taxStateInfoLinkUrl'
                )}
                target='_blank'
                rel='noopener noreferrer'
              >
                <IntlMessage ident='setting.taxRate.taxStateInfoLinkText' />
              </a>
            </div>
            <div className='statelist'>{this._renderStateItems()}</div>
            <div className='actrow'>
              {this.data.showStateAdd && (
                <div className='dropfield'>
                  <Select
                    label='setting.taxRate.placeholderTaxState'
                    className='form-dropdown'
                    options={this._getUsStates()}
                    onChange={this._onCreateState.bind(this)}
                    multilingualOptions={false}
                    name='style'
                  />
                </div>
              )}
              {!this.data.showStateAdd && (
                <div className='addbtn'>
                  <FormButton
                    title='setting.taxRate.statesAddAction'
                    secondary
                    onClick={this._onClickAddState.bind(this)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className='colright'>
            {this.data.taxRates.length > 0 && this._renderForm()}
          </div>
        </div>
      </div>
    )
  }

  _getUsStates () {
    const usStates = this.data.usaStates
    this.data.taxRates.forEach(taxRate => {
      _.remove(usStates, (obj, _objIdx) => obj.value === taxRate.state)
    })

    return usStates
  }

  _onCreateState (value) {
    const createObj = {
      teamId: app.getTeamId(),
      userId: app.loggedInId,
      state: value,
      rates: []
    }

    app
      .service('/api/taxrate')
      .create(createObj)
      .then(result => {
        this.data.showStateAdd = false
        this.data.activeTaxRate = result
        this._reloadData()
      })
      .catch(err => {
        app.debug('page Taxrate _onCreateState err', err)
      })
  }

  _onClickAddState (ev) {
    ev.preventDefault()

    this.data.showStateAdd = true
    this.setState({ dataDate: new Date() })
  }

  _renderStateItems () {
    const activerTaxRate = this.data.activeTaxRate
      ? this.data.activeTaxRate
      : this.data.taxRates.length > 0
      ? this.data.taxRates[0]
      : null

    if (this.data.taxRates && this.data.taxRates.length > 0) {
      return this.data.taxRates.map((taxRateObj, idx) => {
        return (
          <StateListItem
            title={Util.getUsStateFromCode(taxRateObj.state)}
            key={idx}
            ref={this._references[`state-${taxRateObj.id}`]}
            active={activerTaxRate && activerTaxRate.id === taxRateObj.id}
            onClick={this._onClickStateItem.bind(this, taxRateObj, idx)}
            onDelete={this._onShowDelteConfirm.bind(this, taxRateObj, idx)}
            onDeleteConfirm={this._onDeleteState.bind(this, taxRateObj)}
          />
        )
      })
    }

    return ''
  }

  _onShowDelteConfirm (taxRateObj) {
    if (
      this.data.currActiveIdx !== null &&
      this._references[`state-${this.data.currActiveIdx}`]
    ) {
      this._references[
        `state-${this.data.currActiveIdx}`
      ].current.hideConfirmDelete()
    }

    this.data.currActiveIdx = taxRateObj.id
    this.setState({ dataDate: new Date() })
  }

  _onClickStateItem (taxRateObj, idx, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (
      this.data.currActiveIdx !== null &&
      this._references[`state-${this.data.currActiveIdx}`]
    ) {
      this._references[
        `state-${this.data.currActiveIdx}`
      ].current.hideConfirmDelete()
    }

    this.data.activeTaxRate = taxRateObj
    this.data.currActiveIdx = null

    this.setState({ dataDate: new Date() })
  }

  _onDeleteState (taxRateObj) {
    if (!taxRateObj || !taxRateObj.id) {
      return ''
    }

    app
      .service('/api/taxrate')
      .remove(taxRateObj.id)
      .then(_result => {
        this.data.activeTaxRate = null
        this._reloadData()
      })
      .catch(err => {
        app.debug('err', err)
      })
  }

  _renderForm () {
    const activerTaxRate = this.data.activeTaxRate
      ? this.data.activeTaxRate
      : this.data.taxRates.length > 0
      ? this.data.taxRates[0]
      : null

    return (
      <TaxRateForm
        taxRates={
          activerTaxRate && activerTaxRate.rates.length > 0
            ? activerTaxRate.rates
            : []
        }
        onSubmit={this._onSubmit.bind(this, activerTaxRate.id)}
        title={
          activerTaxRate ? Util.getUsStateFromCode(activerTaxRate.state) : ''
        }
        onError={this._onError.bind(this)}
      />
    )
  }

  _onSubmit (activerTaxRateId, taxRates) {
    if (!activerTaxRateId) {
      return ''
    }

    const updateObj = {
      rates: taxRates
    }

    app
      .service('/api/taxrate')
      .patch(activerTaxRateId, updateObj)
      .then(result => {
        this.data.activeTaxRate = result
        this._reloadData()

        if (this._references.pageHeader.current) {
          this._references.pageHeader.current.showSuccess(
            'setting.taxRate.msgSuccessTitle',
            'setting.taxRate.msgSuccessContent'
          )
        }
      })
      .catch(err => {
        app.debug('err', err)
      })
  }

  _onError () {}

  _reloadData () {
    this._getData()
  }

  _updateReferences (taxRates) {
    taxRates.forEach(taxRate => {
      if (!this._references[`state-${taxRate.id}`]) {
        this._references[`state-${taxRate.id}`] = React.createRef()
      }
    })
  }
}

export default PageTaxRate
